/**
 * Enum for Country values.
 * @readonly
 * @enum {string}
 */
export enum ECountry {
  /** Guatemala. @default */
  GT = 'gt',

  /** El Salvador. */
  SV = 'sv',

  /** Costa Rica. */
  CR = 'cr',

  /** Honduras. */
  HN = 'hn',

  /** Nicaragua. */
  NI = 'ni'
}
